// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1-zFo","noPadding":"Button_noPadding__2J4rL","arrowLeft":"Button_arrowLeft__33gUr","arrowRight":"Button_arrowRight__sCOAU","rotate":"Button_rotate__2Xcyo"};